let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kst5l")).then(() => parcelRequire('jI51z'));